<template>
  <CCard>
    <CCardHeader class="d-flex justify-content-end">
      <h2 class="text-uppercase font-weight-bold mb-0">List of Instructors</h2>
      <CButton
        v-if="$auth.check('instructors_create_invite')"
        class="ml-auto mr-3"
        color="primary"
        @click="createIns"
      >
        Add New
      </CButton>
      <CButton class="mx-3" color="primary" @click="openFilters">Filters</CButton>
      <CInput
        v-model="filters.search"
        class="mb-0"
        placeholder="Search"
        @update:value="fetchData"
        @focusout.stop
      />
    </CCardHeader>
    <CCardHeader v-if="filters.status.length > 0">
      Status:
      <span
        v-for="status in filters.status"
        :key="'f-status-' + status"
        class="badge bg-info text-white mr-2 h6 c-pointer"
        @click="removeStatusFilter(status)"
      >
        {{
          statuses.find((s) => s.value === status)
            ? statuses.find((s) => s.value === status).label
            : ''
        }}
        <i class="fas fa-times" />
      </span>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :items="data"
        :fields="c_fields"
        :pagination="false"
        :sorter="{ external: true }"
        :loading="loading"
        class="mb-0"
        @update:sorter-value="sortingChange"
      >
        <template #status="{ item }">
          <td class="text-center">
            {{ item.status }}
          </td>
        </template>
        <template #full_control="{ item }">
          <td class="text-center">
            <input
              type="checkbox"
              :checked="item.full_control"
              @click.prevent="changeControl(item)"
            />
          </td>
        </template>
        <template #app_hidden="{ item }">
          <td class="text-center">
            <input type="checkbox" :checked="item.app_hidden" @click.prevent="changeHidden(item)" />
          </td>
        </template>
        <template #actions="{ item }">
          <td>
            <div class="d-flex">
              <CButton
                v-if="item.status_key === 0"
                size="sm"
                color="success"
                class="text-white mr-2"
                @click="confirmIns(item.id)"
              >
                Confirm
              </CButton>
              <CButton
                v-if="item.status_key === 0"
                size="sm"
                color="danger"
                class="text-white mr-2"
                @click="rejectInstructor(item.id)"
              >
                Reject
              </CButton>
              <CButton
                v-if="item.status_key === 1"
                size="sm"
                color="danger"
                class="text-white mr-2"
                @click="blockInstructor(item.id)"
              >
                Block
              </CButton>
              <CButton
                v-if="item.status_key === 3 && item.status_key !== 2 && item.status_key !== 0"
                size="sm"
                color="success"
                class="text-white mr-2"
                @click="unBlockInstructor(item.id)"
              >
                Unblock
              </CButton>
              <CButton
                v-if="item.status_key !== 2"
                size="sm"
                color="warning"
                class="text-white mr-2"
                @click="editIns(item.id)"
              >
                Edit
              </CButton>
              <CButton size="sm" color="danger" class="text-white" @click="deleteIns(item.id)">
                Delete
              </CButton>
            </div>
          </td>
        </template>
      </CDataTable>
      <pagination
        :current-page="options.page"
        :last-page="options.last_page"
        class="mr-3"
        @paginate="pageChange"
      />
    </CCardBody>
    <filters-modal ref="filters_modal" @apply="changeFilters" />
    <delete-confirm-modal ref="block_modal" @confirmed="blockIns" />
    <delete-confirm-modal ref="delete_modal" @confirmed="destroyIns" />
    <delete-confirm-modal ref="reject_modal" @confirmed="rejectIns" />
  </CCard>
</template>

<script>
import externalTable from '@/mixins/externalTable';
import FiltersModal from '../instructors/FiltersModal';
import DeleteConfirmModal from '../instructors/DeleteConfirmModal';

export default {
  name: 'InstructorList',
  components: { DeleteConfirmModal, FiltersModal },
  mixins: [externalTable],
  data() {
    return {
      filters: {
        search: '',
        status: [],
      },
      statuses: [
        { value: 0, label: 'Pending' },
        { value: 1, label: 'Active' },
        { value: 2, label: 'Rejected' },
        { value: 3, label: 'Blocked' },
        { value: 4, label: 'Invited' },
      ],
      fields: [
        {
          key: 'first_name',
          label: 'First Name',
        },
        {
          key: 'last_name',
          label: 'Last Name',
        },
        {
          key: 'email',
          label: 'Email',
        },
        {
          key: 'app_hidden',
          label: 'Hidden',
        },
        {
          key: 'full_control',
          label: 'Full Control',
        },
        {
          key: 'status',
          label: 'Status',
        },
      ],
      url: '/instructors',
    };
  },
  computed: {
    c_fields() {
      let fields = this.fields.slice(0);
      if (this.$auth.check('instructors_crud')) {
        fields.push({
          key: 'actions',
          label: 'Actions',
          sorter: false,
        });
      }
      return fields;
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    removeStatusFilter(status) {
      this.filters.status = this.filters.status.filter((r) => r !== status);
      this.fetchData();
    },
    openFilters() {
      this.$refs.filters_modal.open(this.filters);
    },
    changeFilters(data) {
      this.options.page = 1;
      this.filters = Object.assign({}, this.filters, data);
      this.fetchData();
    },
    createIns() {
      this.$router.push({ name: 'Invite Instructor' });
    },
    editIns(id) {
      this.$router.push({ name: 'Edit Instructor', params: { id: id } });
    },
    deleteIns(id) {
      this.$refs.delete_modal.open(id);
    },
    changeControl(item) {
      this.$http
        .put('/instructors/' + item.id + '/control')
        .then(() => {
          this.$toast.success('Changed!');
          this.fetchData();
        })
        .catch(({ response }) => this.$toast.error(response.data.message));
    },
    changeHidden(item) {
      this.$http
        .put('/instructors/' + item.id + '/hidden')
        .then(() => {
          this.$toast.success('Changed!');
          this.fetchData();
        })
        .catch(({ response }) => this.$toast.error(response.data.message));
    },
    destroyIns(id) {
      this.$http.delete('/instructors/' + id + '').then(() => {
        this.$toast.success('Deleted!');
        this.fetchData();
      });
    },

    blockInstructor(id) {
      this.$refs.block_modal.open(id);
    },
    unBlockInstructor(id) {
      this.$http.put('/instructors/' + id + '/unblock').then(() => {
        this.$toast.success('Unblocked!');
        this.fetchData();
      });
    },
    blockIns(id) {
      this.$http.put('/instructors/' + id + '/block').then(() => {
        this.$toast.success('Blocked');
        this.fetchData();
      });
    },
    rejectInstructor(id) {
      this.$refs.reject_modal.open(id);
    },
    rejectIns(id) {
      this.$http.put('/instructors/' + id + '/reject').then(() => {
        this.$toast.success('Rejected!');
        this.fetchData();
      });
    },
    confirmIns(id) {
      this.$http.put('/instructors/' + id + '/confirm').then(() => {
        this.$toast.success('Confirmed!');
        this.fetchData();
      });
    },
  },
};
</script>

<style scoped></style>
